import {
  BarChart,
  LineChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label,
  ResponsiveContainer,
} from 'recharts'

const chartComponents = {
  line: LineChart,
  bar: BarChart,
  barStack: BarChart,
}

const categoryComponents = {
  line({ id, name, color }) {
    return (
      <Line
        key={`line-${id}`}
        id={`${id}`}
        name={name}
        dataKey={id}
        stroke={color}
        type="monotone"
      />
    )
  },
  bar({ id, name, color }) {
    return (
      <Bar
        key={`bar-${id}`}
        id={`${id}`}
        name={name}
        dataKey={id}
        fill={color}
      />
    )
  },
  barStack({ id, name, color, stackId }) {
    return (
      <Bar
        key={`barStack-${id}`}
        id={`${id}`}
        name={name}
        dataKey={id}
        fill={color}
        stackId={stackId}
      />
    )
  },
}

const XYChart = ({
  data,
  categories = [],
  chartType,
  xLabel,
  yLabel,
  hiddenLabels,
  renderLegend,
  renderTooltip,
  height = 300,
}) => {
  const Component = chartComponents[chartType]
  const mappedCategories = categories.map(categoryComponents[chartType])
  return (
    // ResponsiveContainer en vez de un ancho fijo: el grafico ocupa todo el
    // contenedor en lugar de dejar aire muerto a la derecha.
    <ResponsiveContainer width="100%" height={height}>
      <Component
        data={data}
        margin={{
          top: 20,
          right: 20,
          left: 20,
          bottom: 20,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" hide={hiddenLabels}>
          <Label value={xLabel} offset={0} position="insideBottomRight" />
        </XAxis>
        <YAxis domain={[0, `dataMax`]}>
          <Label angle={-90} value={yLabel} offset={0} position="left" />
        </YAxis>
        <Tooltip content={renderTooltip} />
        {/* Sin `height` fijo: recharts mide la leyenda y le reserva justo lo
            que ocupa. Fijarlo dejaba un hueco cuando la leyenda necesitaba
            menos filas de las previstas. El tope lo pone su propio
            maxHeight, y lo que sobra se lo queda el area de ploteo. */}
        <Legend
          content={renderLegend}
          layout="horizontal"
          align="center"
          verticalAlign="bottom"
        />
        {mappedCategories}
      </Component>
    </ResponsiveContainer>
  )
}

export default XYChart
